import { CTFRow } from "../CTFRow";

export class CFTUtil
{
    static get(name: string, row: any): CTFRow
    {
        return {
            categories: row[name + "_category"] ?? [],
            fields: row[name + "_field"] ?? [],
            tags: row[name + "_tag"] ?? [],
        };
    }
    static set(name: string, row: any, ctf: CTFRow)
    {
        row[name + "_field"] = ctf.fields;
        row[name + "_category"] = ctf.categories;
        row[name + "_tag"] = ctf.tags;
    }
}